// 토스트 이벤트 에미터
// axios 인터셉터에서 React 컨텍스트를 직접 사용할 수 없으므로 이벤트 기반으로 처리

class ToastEventEmitter {
  constructor() {
    this.listeners = [];
  }

  subscribe(callback) {
    this.listeners.push(callback);
    return () => {
      this.listeners = this.listeners.filter((listener) => listener !== callback);
    };
  }

  emit(message, severity = 'error') {
    this.listeners.forEach((listener) => listener({ message, severity }));
  }

  success(message) {
    this.emit(message, 'success');
  }

  error(message) {
    this.emit(message, 'error');
  }

  warning(message) {
    this.emit(message, 'warning');
  }

  info(message) {
    this.emit(message, 'info');
  }
}

const toast = new ToastEventEmitter();

export default toast;

